module.exports = __webpack_public_path__ + "img/btn-personal-info-en.f1df29fc.png";